<template>
  <div class="container-fluid">
    <div
      v-for="(attribute, index) in errors"
      :key="index"
      class="alert alert-danger"
    >
      <div v-for="error in attribute" v-bind:key="error">
        {{ error }}
      </div>
    </div>
    <h4 class="m-3">Добавление акции</h4>
    <el-form
      ref="form"
      :model="form"
      label-width="120px"
      id="uploadForm"
      name="uploadForm"
      enctype="multipart/form-data"
      class="action-add__form"
    >
      <el-form-item label="Название">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="Подзаголовок">
        <el-input
          type="textarea"
          class="action-form__subtitle"
          v-model="form.subtitle"
        ></el-input>
      </el-form-item>
      <el-form-item label="Описание">
        <el-input
          type="textarea"
          class="action-form__description"
          v-model="form.description"
        ></el-input>
      </el-form-item>
      <el-form-item label="Плашка">
        <div class="action-form__label">
          <p class="action-label__name">Фоновый цвет</p>
          <el-color-picker v-model="form.label.color" size="large" />
          <p class="action-label__name">Текст</p>
          <el-input v-model="form.label.title"></el-input>
          <p class="action-label__name">Краткий текст</p>
          <el-input v-model="form.label.short_title"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="Приоритет">
        <el-input v-model="form.priority"></el-input>
      </el-form-item>
      <el-form-item label="Сортировка">
        <el-input v-model="form.sort"></el-input>
      </el-form-item>
      <el-form-item label="Активность">
        <el-checkbox v-model="form.activity"></el-checkbox>
      </el-form-item>
      <el-form-item label="Изображение">
        <input
          type="file"
          id="files"
          ref="files"
          accept=".jpeg,.png,.gif"
          v-on:change="handleFilesUpload()"
          class="mb-3"
        />
        <div class="row" v-for="(file, index) in files" :key="index">
          <div class="col-md-5 mb-3">
            <img v-bind:ref="`image${index}`" style="height: 100px" />
            <a @click="deleteFile(index)" class="el-icon-close"></a>
          </div>
        </div>
      </el-form-item>
      <el-row>
        <el-col :span="+4">
          <el-form-item label="Действует с">
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy/MM/dd"
              placeholder="Select date"
              v-model="form.from_date"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="+4">
          <el-form-item label="по">
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy/MM/dd"
              placeholder="Select date"
              v-model="form.to_date"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <hr />
      <el-form-item>
        <h6>Тип акции</h6>
        <el-tabs v-model="form.type" type="border-card">
          <el-tab-pane label="Товар в подарок" name="product_gift">
            <el-form-item
              label-width="50%"
              label="Товары для подарка"
            >
              <el-button
                type="primary"
                @click="(e) => openProductSelectPopup(e)"
              >
                Выбрать товары
              </el-button>
              <p>Выбрано: {{ selectedProductCounter }}</p>
            </el-form-item>
            <el-form-item label-width="50%" label="Товары/товар в подарок">
              <el-button type="primary" @click="(e) => openGiftSelectPopup(e)"
                >Выбрать подарки
              </el-button>
              <p>Выбрано: {{ selectedProductGiftCounter }}</p>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="Скидка на товары" name="discount_on_products">
            <el-form-item label="Товары">
              <el-button
                type="primary"
                @click="$store.commit('showProductsDialog', true)"
                >Выбрать товары</el-button
              >
              <p>Выбрано: {{ productsIds.length }}</p>
            </el-form-item>
            <el-form-item label="Скидка (%)">
              <el-input v-model="form.discount" type="number"></el-input>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="Скидка на категорию" name="discount_on_section">
              <el-form-item label-width="40%" label="Категория">
                <el-button size="small" type="primary" @click="toggleDialog()">Выбрать</el-button>
                <el-tag v-if="selectedSections.length">
                  Выбрано: {{ selectedSections.length }}
                </el-tag>
            </el-form-item>
            <el-form-item label="Скидка (%)" label-width="40%">
              <el-input v-model="form.discount" type="number"></el-input>
            </el-form-item>
            <CatalogSectionDialog
              v-if="form.type === 'discount_on_section' && $store.getters.showCatalogSectionDialog"
              :items-payload="selectedSections"
              :returns-ids="true"
              @saveItems="onSaveItems"
              />
          </el-tab-pane>
          <el-tab-pane
            label="Скидка на товары определенного производителя"
            name="discount_on_maker"
          >
            <el-form-item label="Производитель">
              <el-select v-model="form.maker_id" filterable clearable>
                <el-option
                  v-for="item in makers"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Скидка (%)">
              <el-input v-model="form.discount" type="number"></el-input>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </el-form-item>
      <hr />
      <el-form-item label="Тэги">
        <el-row>
          <el-col :span="+4">
            <el-select v-model="form.tags" multiple filterable>
              <el-option
                v-for="item in tags"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="+2">
            <el-button
              type="primary"
              @click="$store.commit('promoActionTagCreateDialog', true)"
              >Добавить тэг</el-button
            >
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="storePromoAction()"
          >Добавить</el-button
        >
        <el-button @click="back()">Отмена</el-button>
      </el-form-item>
    </el-form>
    <create-promo-action-tag-dialog
      @updateParent="Update"
    ></create-promo-action-tag-dialog>
    <select-products
      :selectedProducts="form.products"
      @select-product="(e) => selectProduct(e)"
      v-if="$store.getters.showProductsDialog"
    ></select-products>
    <select-products-gifts
      :selectedProducts="form.products"
      :selectedGifts="form['gift_products']"
      @select-product="(e) => selectGift(e)"
      v-if="$store.getters.showProductsGiftDialog"
    ></select-products-gifts>
  </div>
</template>

<script>
import axios from "axios";
import CreatePromoActionTagDialog from "@/components/PromoActions/PromoActionTagCreateDialog";
import SelectProducts from "@/components/Products/SelectProducts";
import CatalogSectionDialog from '../CatalogSectionDialog';
import SelectProductsGifts from "@/components/Products/SelectProductsGifts";
import { SETPRELOADER_STATE } from "../../store/mutation-types.js";
import useAction from "@/composable/useAction.js";
import useFormData from '../../composable/useFormData.js';

export default {
  components: {
    SelectProductsGifts,
    SelectProducts,
    CreatePromoActionTagDialog,
    CatalogSectionDialog,
  },
  data: function () {
    return {
      form: {
        title: "",
        description: "",
        from_date: "",
        to_date: "",
        type: "product_gift",
        discount: 0,
        subtitle: "",
        sort: 1,
        activity: true,
        priority: 1,
        products: [],
        maker_id: '',
        catalog_section_id: '',
        'gift_products': [],
        tags: [],
        label: {
          color: "",
          short_title: "",
          title: "",
        },
        image: ''
      },
      selectedSections: [],
      flag1: false,
      flag2: false,
      flag3: false,
      flag4: false,
      files: [],
      products: [],
      categories: [],
      productsIds: [],
      status: 0,
      productsGiftIds: [],
      errors: [],
      tags: [],
      makers: [],
      selectedProductCounter: 0,
      selectedProductGiftCounter: 0,
    };
  },
  mounted() {
    this.tags = this.$store.getters.actionTags;
    this.makers = this.$store.getters.actionMakers;

    if (!this.tags.length || !this.makers.length) {
      this.getActionData();
    }

    const action = useAction.bind(this)
    const { actionTypes } = action()

    this.actionTypes = actionTypes
  },
  methods: {
    getActionData() {
      this.$store.commit(SETPRELOADER_STATE, true);

      Promise.all([this.getTags(), this.getMakers()])
        .then((response) => {
          const [tags, makers] = response;

          this.tags = tags.data;
          this.makers = makers.data;
        })
        .finally(() => {
          this.$store.commit(SETPRELOADER_STATE, false);
        });
    },
    getMakers() {
      return axios.get("/promo-action/maker");
    },
    getTags() {
      return axios.get("/promo-action/tag");
    },
    Update(newTag) {
      this.tags.push(newTag);
    },
    back() {
      this.$router.go(-1);
    },
    deleteFile(index) {
      this.files.splice(index, 1);
      this.getImagePreviews();
    },
    getImagePreviews() {
      this.files.forEach((item, index) => {
        const reader = new FileReader();

        reader.addEventListener(
          "load",
          () => {
            this.$refs[`image${index}`][0].src = reader.result;
          },
          false
        );

        reader.readAsDataURL(this.files[index]);
      });
    },
    addFiles() {
      this.$refs.files.click();
    },
    handleFilesUpload() {
      this.files = [...Array.from(this.$refs.files.files)];

      this.getImagePreviews();
    },
    selectProduct(productSelectCounter) {
      this.selectedProductCounter = productSelectCounter;
    },
    selectGift(giftSelectCounter) {
      this.selectedProductGiftCounter = giftSelectCounter;
    },
    storePromoAction() {
      this.form.products = [...this.form.products.map((item) => item.id)]
      this.form['gift_products'] = [...this.form['gift_products'].map((item) => item.id)]

      const data = useFormData().execute().setFields([
      'image',
      'title',
      'description',
      'from_date',
      'to_date',
      'type',
      'subtitle',
      'sort',
      'activity',
      'priority',
      'label',
      'products',
      'gift_products',
      'tags',
      'catalog_section_id',
      'maker_id'
    ]).getFormData(this.form)

    data.append('image', this.$refs.files.files[0])

    const currentTypes = this.actionTypes.find((el) => el.name === this.form.type)

    if (currentTypes) {
      currentTypes.append(data)
    }

    axios
      .post("/promo-action/", data)
      .then((response) => {
        this.status = response.status;
        this.back();
      })
      .catch((errors) => {
        if (errors.response.status === 401) {
          this.$router.push("/login");
        }

         this.errors = errors.response.data.errors;
      });
    },
    openProductSelectPopup() {
      this.$store.commit("showProductsDialog", true);
    },
    openGiftSelectPopup() {
      this.$store.commit("showProductsGiftDialog", true);
    },
    toggleDialog() {
      this.$store.commit('showCatalogSectionDialog', !this.$store.getters.showCatalogSectionDialog);
    },
    setFormSection(){
      this.form.catalog_section_id = this.selectedSections[0] ?? ''
    },
    handleDeleteCat(index){
      this.selectedSections.splice(index, 1)
      this.setFormSection()
    },
    onSaveItems(items) {
      this.selectedSections = items
      this.setFormSection()
    }
  },
};
</script>

<style lang="scss">
  .action-form {
    &__label {
      margin-top: 40px;
    }

    &__subtitle,
    &__description {
      textarea {
        resize: none
      }
    }
  }

  .action-label {
    &__name {
      color: #606266;
      margin-bottom: 5px;

      &:not(:first-child) {
        margin-top: 10px;
      }
    }
  }
</style>
